

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AlpacaPreview from '@/components/AlpacaPreview.vue';
import { ROUTE_ALPACAS, ROUTE_ADOPT, ROUTE_AIRDROP, ROUTE_FARM } from '@/router';
import { getCityInfo } from '@/backend/requests';
import { totalBurnedAlpa } from '@/utils/web3';
import CountDown from '@/components/CountDown.vue';
import BigNumber from 'bignumber.js';
import { balanceOf } from '@/utils/web3';
import { alpaUnit } from '@/utils/unit';
import { claim, wearableTypeClaimed } from '@/contract/wearableOperator';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
    AlpacaPreview,
    CountDown,
  },
})
export default class Home extends Vue {
  public cityInfo: any = null;
  public totalBurned = new BigNumber(-1);
  public wearableClaimed = false;
  public activityInterval: number = 0;
  public inActivity: boolean = false;

  get ROUTE_ALPACAS() {
    return ROUTE_ALPACAS;
  }

  get ROUTE_ADOPT() {
    return ROUTE_ADOPT;
  }

  get ROUTE_AIRDROP() {
    return ROUTE_AIRDROP;
  }

  get ROUTE_FARM() {
    return ROUTE_FARM;
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get totalAlpacas() {
    if (this.cityInfo) {
      return this.$options.filters!.numberToBMK(this.cityInfo.alpacas_count);
    }
    return '-';
  }

  get activity() {
    return this.$store.getters.activity;
  }

  get beforeActivity() {
    return new Date().getTime() < this.activity.start;
  }

  get totalPlayers() {
    if (this.cityInfo) {
      return this.$options.filters!.numberToBMK(this.cityInfo.shepherds_count);
    }
    return '-';
  }

  get totalBurnedNum() {
    if (this.totalBurned.isGreaterThan(-1)) {
      return this.$options.filters!.numberToBMK(this.totalBurned);
    }
    return '-';
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  public async mounted() {
    await this.getCityInfo();
    this.getTotalBurnedAlpa();
    this.setActivityInterval();
  }

  public beforeDestroy() {
    if (this.activityInterval) {
      window.clearInterval(this.activityInterval);
    }
  }

  public routeTo(name: string) {
    this.$router.push({name});
  }

  public async getCityInfo() {
    const res = await getCityInfo();
    if (res) {
      this.cityInfo = res.data;
    }
  }

  public async getTotalBurnedAlpa() {
    const amount = this.isBSC
      ? (this.cityInfo ? alpaUnit(this.cityInfo.burned_alpas) : 0)
      : await totalBurnedAlpa();
    if (amount) {
      this.totalBurned = new BigNumber(amount);
    }
  }

  public async getWearableTypeClaimed() {
    const claimed = await wearableTypeClaimed(this.account, 1);
    if (claimed) {
      this.wearableClaimed = claimed;
    }
  }

  public async setActivityInterval() {
    const now = new Date().getTime();
    if (now >= this.activity.start && now <= this.activity.end) {
      this.inActivity = true;
    }
    this.activityInterval = window.setInterval(() => {
      const nowTime = new Date().getTime();
      if (nowTime >= this.activity.start && nowTime <= this.activity.end) {
        this.inActivity = true;
        window.clearInterval(this.activityInterval);
      }
    }, 1000);
  }

  public handleClaim() {
    claim(1, this.account);
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getWearableTypeClaimed();
    }
  }
}
